export default "__VITE_ASSET__DrBdXvhP__"